export default {
  title: "RH Anchor",
  type: "rh/components/content/rhanchor",
  isContainer: false,
  config: {
    emptyLabel: "RH Anchor",
    isEmpty: () => false
  }
};
